"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLTableItemCell = void 0;
const lib_palette_1 = require("@opsbase/lib-palette");
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const RendererRegistry_1 = __importDefault(require("@opsbase/web-data-renderer/RendererRegistry"));
const useDVL_1 = __importDefault(require("@opsbase/web-dvl/useDVL"));
const Link_1 = __importDefault(require("@opsbase/web-nav/Link"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const react_1 = __importStar(require("react"));
const DVLTableCell_1 = __importDefault(require("../DVLTableCell"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView/useView"));
function DVLTableItemCell(props) {
    const dt = (0, useDataTree_1.default)();
    const { nodeKey, item, field, colIdx, rowIdx, isLastCol, className, onMouseEnter, onMouseLeave, } = props;
    const { pinField } = (0, useView_1.default)(dt.viewId);
    const { itemPage, onItemClick } = (0, useDVL_1.default)();
    const renderer = (0, react_1.useRef)(RendererRegistry_1.default.get(field, rowIdx, false));
    const { pathname } = (0, useNav_1.default)();
    const node = dt.nodesByKey.get(nodeKey);
    const isFirstCol = colIdx === 0;
    const isPinned = (pinField === null || pinField === void 0 ? void 0 : pinField.key) === field.key && colIdx === 1;
    const href = (0, react_1.useMemo)(() => {
        const page = typeof itemPage === 'function' ? itemPage(item) : itemPage;
        return !!page ? page.split('*').join(pathname).replace(':id', item.id) : undefined;
    }, [item, itemPage, pathname]);
    const handleItemClick = (0, react_1.useCallback)(() => {
        onItemClick(item);
    }, [item, onItemClick]);
    (0, react_1.useEffect)(() => {
        renderer.current = RendererRegistry_1.default.get(field, rowIdx, false);
    }, [field, rowIdx]);
    const innards = renderer.current(item, 1 + (rowIdx + node.page * dt.pageSize));
    return (0, react_1.useMemo)(() => {
        let outards = innards;
        if (href && isFirstCol)
            outards = (react_1.default.createElement(Link_1.default, { style: { color: lib_palette_1.Palette.secondary.main }, href: href }, innards));
        else if (onItemClick && isFirstCol)
            outards = (react_1.default.createElement(Link_1.default, { style: { color: lib_palette_1.Palette.secondary.main }, onClick: handleItemClick }, innards));
        return (react_1.default.createElement(DVLTableCell_1.default, { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, width: field.width, key: 'item_' + colIdx, isFirstCol: isFirstCol, isLastCol: isLastCol, isPinned: isPinned, className: className, padded: true }, outards));
    }, [
        innards,
        href,
        isFirstCol,
        isPinned,
        onItemClick,
        handleItemClick,
        onMouseEnter,
        onMouseLeave,
        field,
        colIdx,
        isLastCol,
        className,
    ]);
}
exports.DVLTableItemCell = DVLTableItemCell;
exports.default = DVLTableItemCell;
